import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { useSessionTracking } from "@/hooks/useSessionTracking";
import { WorkflowProgressBar } from "./WorkflowProgressBar";
import { FloatingAskFint } from "./FloatingAskFint";

export function DashboardLayout() {
  useSessionTracking();

  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => { e.preventDefault(); return false; };
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && (e.key === 'c' || e.key === 'u' || e.key === 's' || e.key === 'p')) { e.preventDefault(); return false; }
      if (e.key === 'F12') { e.preventDefault(); return false; }
      if (e.ctrlKey && e.shiftKey && e.key === 'I') { e.preventDefault(); return false; }
    };
    const handleCopy = (e: ClipboardEvent) => { e.preventDefault(); return false; };
    const handleDragStart = (e: DragEvent) => { e.preventDefault(); return false; };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
    };
  }, []);

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <AppSidebar />
        <main className="flex-1 flex flex-col">
          <header className="h-16 border-b border-border flex items-center justify-between px-6">
            <div className="flex items-center gap-4">
              <SidebarTrigger />
            </div>
            <div className="flex items-center gap-4">
              <span className="text-sm text-muted-foreground">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium">
                  Active Member
                </span>
              </span>
            </div>
          </header>

          {/* Workflow Progress Bar */}
          <WorkflowProgressBar />
          
          <div className="flex-1 overflow-auto">
            <Outlet />
          </div>

          {/* Floating AskFint Button */}
          <FloatingAskFint />
        </main>
      </div>
    </SidebarProvider>
  );
}
